<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <channel-state
        :channel-state="webPushState"
        devices
      ></channel-state>

      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="webPush.isEnabled"
              label="Канал включён"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="webPush.ttlHours"
              label="Срок жизни пуша, часов"
              hint="Сколько пуш ждёт закрытый браузер"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('ttlHours')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="webPush.ratePerMinute"
              label="Скорость рассылки, устройств в минуту"
              hint="Весь список разом — это волна заказов, которую кухня и колл-центр не разберут"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('ratePerMinute')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="webPush.staleTokenDays"
              label="Браузер неактивен через, дней"
              hint="Через сколько дней молчания подписка браузера считается неактивной"
              persistent-hint
              type="number"
              dense
              outlined
              :rules="[rules.required, rules.integerValidator]"
              :error-messages="messages('staleTokenDays')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.siteUrl"
              label="Адрес сайта"
              hint="https://… — к нему приклеивается путь из рассылки"
              persistent-hint
              dense
              outlined
              :error-messages="messages('siteUrl')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.iconUrl"
              label="Значок уведомления"
              hint="https-адрес картинки"
              persistent-hint
              dense
              outlined
              :error-messages="messages('iconUrl')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-divider class="mb-2"></v-divider>
            <span class="text-subtitle-2">Веб-приложение Firebase</span>
            <p class="text-caption text--secondary mb-0">
              Параметры берутся в консоли Firebase: Настройки проекта → Общие → веб-приложение
              и Cloud Messaging → Web Push certificates. Они не секретные: сайт отдаёт их
              браузеру. Пока они не заполнены, сайт подписку не предлагает.
            </p>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.firebaseApiKey"
              label="apiKey"
              dense
              outlined
              :error-messages="messages('firebaseApiKey')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.firebaseProjectId"
              label="projectId"
              dense
              outlined
              :error-messages="messages('firebaseProjectId')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.firebaseMessagingSenderId"
              label="messagingSenderId"
              dense
              outlined
              :error-messages="messages('firebaseMessagingSenderId')"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="webPush.firebaseAppId"
              label="appId"
              dense
              outlined
              :error-messages="messages('firebaseAppId')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model="webPush.vapidKey"
              label="Ключ Web Push (VAPID)"
              dense
              outlined
              :error-messages="messages('vapidKey')"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              :loading="saving === 'webPush'"
              :disabled="hasNotPermission('Permissions.NotificationSettingsUpdate')"
              @click="saveData"
            >
              Сохранить
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'
import { rules } from '@/helpers/validation'
import { errorMessages, hasPermission } from '@/helpers'
import ChannelState from '@/views/notification-settings/channel-state.vue'

export default {
  name: 'WebPushSettingForm',
  components: { ChannelState },
  data: () => ({
    rules,
  }),
  computed: {
    ...mapFormHandlers('notificationSettings', [
      'webPush.isEnabled',
      'webPush.ttlHours',
      'webPush.ratePerMinute',
      'webPush.staleTokenDays',
      'webPush.siteUrl',
      'webPush.iconUrl',
      'webPush.firebaseApiKey',
      'webPush.firebaseProjectId',
      'webPush.firebaseMessagingSenderId',
      'webPush.firebaseAppId',
      'webPush.vapidKey',
    ]),
    ...mapState('notificationSettings', ['webPushState', 'saving']),
    ...mapGetters('notificationSettings', ['errorsOf']),
  },
  methods: {
    ...mapActions('notificationSettings', ['update']),
    hasNotPermission(value) {
      return !hasPermission(value)
    },
    messages(property) {
      return errorMessages(this.errorsOf('webPush'), property)
    },
    async saveData() {
      if (this.$refs.form.validate()) {
        await this.update('webPush')
      }
    },
  },
}
</script>
